import { autoinject } from 'aurelia-dependency-injection';
import { ISecurityContext } from '@asuresoftware/asure.auth';

import { TokenService } from '../support/TokenService';
import { AccountService } from '../support/AccountService';
import { AccountData, Tenant } from '../models';
import { AppHistory } from './AppHistory';
import { ToasterState } from './ToasterState';

interface ILocation {
  pathname: string;
  queryParams: {
    [key: string]: string;
  };
}

export interface ICompany {
  name: string;
  code: string;
  ids: {
      evo: string;
      ahr?: string;
      smartOffice: string;
  };
}

export class PortalFramework {
  public location: ILocation;

  constructor(
    private tokenService: TokenService,
    private accountService: AccountService,
    public account: AccountData,
    public tenant: Tenant,
    public company: ICompany,
    public securityContext: ISecurityContext,
    public toaster: ToasterState
  ) { }

  getAccessToken = () => {
    return this.tokenService.getAccessToken();
  }
  on401 = async () => {
    await this.accountService.authenticateViaRedirect();
  }
}

@autoinject
export class PortalFrameworkBuilder {

  constructor(private tokenService: TokenService, private accountService: AccountService, private history: AppHistory, private toasterState: ToasterState) { }

  build = ({ securityContext, tenant, company }: { securityContext: ISecurityContext, tenant: Tenant, company: ICompany, toaster: ToasterState }) => {

    const account = securityContext.principal;
    const framework = new PortalFramework(this.tokenService, this.accountService, account, tenant, company, securityContext, this.toasterState);

    const updateFrameworkWithLocation = () => {
      const { pathname, search } = this.history.location;

      const queryParams = {};

      new URLSearchParams(search).forEach((value, key) => {
        queryParams[key] = value;
      });

      framework.location = {
        pathname, queryParams
      };
    };

    this.history.listen(updateFrameworkWithLocation);

    updateFrameworkWithLocation();

    return framework;
  }
}



// WEBPACK FOOTER //
// ./src/framework/PortalFramework.ts